import { Tooltip } from "primereact/tooltip";
import { LanguageProficiencyConstants } from "../../../constants/language-proficiency";
import { getCountryCodeFromLanguage, getLanguageName } from "../../../helpers/countryHelper";
import { getCurrentUserFromLocalStorage, getI18nLanguageFromLocalStorage } from "../../../helpers/localStorageHelper";
import { getLanguageDisplayName } from "../../../helpers/languageHelper";
import HeartButton from "./common/HeartButton";
import LanguageFlag from "./common/LanguageFlag";
import LanguageTag from "./common/LanguageTag";
import StarRating from "./common/StarRating";
import { useState } from "react";
import { useEffect } from "react";
import formatRating from "../../../helpers/formatRating";
import { Button } from "primereact/button";
import { CurrencyText } from "../../common/CurrencyText";
import { translate } from "../../../localization/translateService";
const NewTrainerHeaderItemV2 = ({
  source,
  onViewMoreClick,
  props,
  onFavoriteClick,
  showMoreInformation = true,
  displayNameClassName = "keduall-typography text-default-txt heading-h5-semibold-600",
  enableTagsCollapse = false,
  maximumTagItem = 9,
  maximumLanguageItem = 2,
  lang = "en"
}) => {
  const currentUser = getCurrentUserFromLocalStorage();

  const [showAllTags, setShowAllTags] = useState(false);
  const [showAllLangs, setShowAllLangs] = useState(false);
  const [isButtonHovered, setIsButtonHovered] = useState(false);

  const [language, setLanguage] = useState("");
  const [requestLessonLabel, setRequestLessonLabel] = useState("");

  useEffect(() => {
    const language = getI18nLanguageFromLocalStorage();
    setLanguage(language);
  }, []);

  useEffect(() => {
    translate("UMBRACO_LANDING.TRAINER.REQUEST_LESSON_BUTTON").then(setRequestLessonLabel);
  }, []);

  const getTrainerLevelsBadge = (code) => {
    return LanguageProficiencyConstants[code]?.badge || "";
  };

  const renderTags = () => {
    const tags = source.trainerTags ?? [];
    const hasMoreTags = tags.length > maximumTagItem;

    return (
      <>
        {tags.slice(0, showAllTags ? undefined : maximumTagItem)
          .map((trainerTag, index) => (
            <div
              key={`level-${index}`}
              className="flex align-items-center gap-2"
            >
              <LanguageTag
                text={trainerTag.description}
                styleClass={`keduall-typography text-12-medium-500 keduall-badge keduall-badge-primary-button`}
              />
            </div>
          ))}
        
        {hasMoreTags && !showAllTags && (
          <div 
            className={`flex align-items-center gap-2 ${enableTagsCollapse ? 'cursor-pointer' : ''}`} 
            key="extra-tags"
            onClick={(e) => {
              e.stopPropagation();
              if (enableTagsCollapse && (e.target === e.currentTarget || e.currentTarget.contains(e.target))) {
                setShowAllTags(true);
              }
            }}
          >
            <LanguageTag
              text={`+${tags.length - maximumTagItem}`}
              styleClass={`keduall-typography text-12-medium-500 keduall-badge keduall-badge-extra-button`}
            />
          </div>
        )}

        {showAllTags && enableTagsCollapse && (
          <div 
            className="flex align-items-center gap-2 cursor-pointer"
            onClick={(e) => {
              e.stopPropagation();
              if (e.target === e.currentTarget || e.currentTarget.contains(e.target)) {
                setShowAllTags(false);
              }
            }}
          >
            <LanguageTag
              text={props.btnReadLess}
              styleClass={`keduall-typography text-12-medium-500 keduall-badge keduall-badge-extra-button`}
            />
          </div>
        )}
      </>
    );
  };

  const renderLanguages = () => {
    const langs = source.trainerLanguages ?? [];
    const hasMoreLangs = langs.length > maximumLanguageItem;

    return (
      <>
        {langs.slice(0, showAllLangs ? undefined : maximumLanguageItem)
          .map((lang, index) => (
            <>
              <div
                key={`lang-${index}`}
                className="flex align-items-center gap-1"
              >
                <span
                  className={` ${getCountryCodeFromLanguage(lang.languageCode)}`}
                >
                  {getLanguageName(lang.languageCode)}
                </span>
                <span
                  className={`${getCountryCodeFromLanguage(lang.languageCode)}-${index}`}
                >
                  ({lang.proficiencyDescription})
                </span>
              </div>
              {index !== source.trainerLanguages.length - 1 && <span className="mr-2">,</span>}
              
            </>
          ))}
        
        {hasMoreLangs && !showAllLangs && (
          <div 
            className={`flex align-items-center gap-2 cursor-pointer`} 
            key="extra-tags"
            onClick={(e) => {
              e.stopPropagation();
              if (e.target === e.currentTarget || e.currentTarget.contains(e.target)) {
                setShowAllLangs(true);
              }
            }}
          >
            +{langs.length - maximumLanguageItem}
          </div>
        )}
      </>
    );
  };

  const buyTicket = () => {
    if (currentUser) {
      const query = new URLSearchParams({
            isQuickBuy: true,
            productId: source.productId,
            quantity: 1
          }).toString();
      window.location.href = `/${currentUser.defaultLanguage}/shopping-cart?${query}`;
    } else {
      window.location.href = `/auth/login?lang=${lang}&returnUrl=${window.location.pathname}`;
    }
  };

  return (
    <div
      className="flex flex-column h-full w-full align-items-center cursor-pointer"
      onClick={onViewMoreClick}
    >
      <div className="trainer-thumbnail w-full">
        <img
          src={source.profilePicture ?? props.defaultProfilePicture}
          alt={`${source.displayName} profile`}
          className="avatar w-full h-full object-fit--cover"
        />
      </div>
      <div className="flex flex-column flex-1 w-full">
        <div className="flex flex-column gap-2 trainer-header-item flex flex-column gap-2 trainer-header-item justify-content-between h-full align-items-center">
          <div className="flex align-items-center gap-3">
            <LanguageFlag
              code={source.country}
              className={"keduall-icon keduall-typography text-14-medium-500 flag-rectangle-country flex-shrink-0"}
            />
            <h4 className={`${displayNameClassName}`}>
              {source.nickName || source.displayName}                   
            </h4>
            
          </div>
          <div className="flex align-items-center gap-2 flex-column">
            <div className="keduall-text one-row-ellipsis keduall-typography heading-h5-semibold-600">
              {source.introductionVideoTitle}
            </div>            
            <div className="keduall-text two-row-ellipsis keduall-typography heading-h6-semibold-600 mt-2">
              {source.introductionVideoDescription}
            </div>
          </div>

          <Button
            className={`keduall-buttons ${isButtonHovered ? "button-outlined-small-secondary" : "button-filled-default-small-primary"} keduall-typography text-14-semibold-600 w-full`}
            label={isButtonHovered ? <CurrencyText amount={source.price} sourceCurrency={source.currency} /> : requestLessonLabel}
            onMouseEnter={() => setIsButtonHovered(true)}
            onMouseLeave={() => setIsButtonHovered(false)}
            onClick={(e) => {
              e.stopPropagation();
              buyTicket();
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default NewTrainerHeaderItemV2;
